export enum MetricFilter {
    Total = "TOTAL",
    Booked = "BOOKED",
    Billed = "BILLED",
}

export const METRIC_PRESETS = [
    {
        label: "Total",
        value: MetricFilter.Total,
    },
    {
        label: "Booked Margin",
        value: MetricFilter.Booked,
    },
    {
        label: "Billed Margin",
        value: MetricFilter.Billed,
    },
];